
export function newEngine() {
    /* this path is relative to the snippets directory */
    return new Worker(new URL('../../engine.js', import.meta.url), {
        type: 'module'
    });
}
